module.exports = __webpack_public_path__ + "static/media/1st.3c91236c.jpg";